export default "__VITE_ASSET__DCm$5iZu__"